import { Notification } from '../interfaces/notification.interface';
import { JOBS_AND_TESTS_PAGE_URL } from '../pages/dashboard/jobs-and-tests/jobs-and-tests.page';

export function getNotificationLink(notification: Notification): string | null {
  const { referenceOrderId, referenceEntityType, referenceEntityId } =
    notification;

  if (!referenceEntityType || !referenceEntityId) {
    return null;
  }

  switch (referenceEntityType) {
    case 'SAMPLE':
      return referenceOrderId
        ? `${JOBS_AND_TESTS_PAGE_URL}/job/${referenceOrderId}/samples/${referenceEntityId}`
        : null;

    default:
      return null;
  }
}
